<!-- Young -->
<template>
  <div class="version-manage">
    <public-bread-crumb :routes="routes" />
    <public-top-bar
      placeholder="请输入版本号、设备型号"
      :topBarBtns="topBarBtns"
      :showHighSearch="true"
      :onTableSearchFun="onTableSearchFun"
      @changeBasicSearchFun="changeBasicSearchFun"
    >
      <template v-slot:highSearchGroup>
        <a-range-picker
          class="top-bar-input"
          :placeholder="['请选择上传开始时间', '请选择上传结束时间']"
          :format="dateFormat"
          @change="setDateRange"
        />
        <a-select
          placeholder="请选择"
          class="top-bar-input"
          allowClear
          v-model="searchObj.type"
        >
          <a-select-option value="">全部</a-select-option>
          <a-select-option
            v-for="(i, index) in topSelects"
            :key="index"
            :value="i"
            >{{ i }}</a-select-option
          >
        </a-select>
      </template>
    </public-top-bar>
    <public-table
      :columns="columns"
      :tableData="tableData"
      :tableInfo="tableInfo"
      :operateA="operateA"
      :operateWidth="operateWidth"
      :tableLoading="tableLoading"
      @selectTableRowFun="selectTableRowFun"
      @sortChangeFun="tableSorterFun"
    >
      <!-- 版本大小 -->
      <template slot="size" slot-scope="scope">
        <span>{{ scope.row.size + "M" }}</span>
      </template>
      <!-- 上传结果 -->
      <template slot="status" slot-scope="scope">
        <div v-if="scope.row.status == 1">
          <span style="color:#3cbd6c">上传成功</span>
        </div>
        <div v-else-if="scope.row.status == 2">
          <span style="color:#f00" @click="addPageOrEditPage(scope.row)"
            >上传失败，点击重试</span
          >
        </div>
        <div v-else style="width: 130px">
          <a-progress
            :percent="scope.row.percentage"
            strokeColor="#6560c7"
            size="small"
          />
        </div>
      </template>
    </public-table>
    <public-del
      ref="delWeight"
      delDesc="数据删除后不可恢复，是否确定？"
      :btnLoading="btnLoading"
      :delTableDataFun="delTableDataFun"
    />
  </div>
</template>

<script>
import { publicTableList } from '@/mixins/mixinsData'
import VersionServices from '@/services/version.services'
import { mapGetters, mapMutations } from 'vuex'
export default {
  name: 'VersionManage',
  mixins: [publicTableList],
  data () {
    return {
      versionManageflag: true,
      routes: [
        {
          name: '版本管理',
          path: '/version'
        }
      ],
      topBarBtns: [
        {
          name: '上传',
          type: 'primary',
          fun: this.addPageOrEditPage
        },
        {
          name: '删除',
          type: '',
          fun: this.topBarDelBtnFun
        },
        {
          name: '全选',
          type: '',
          fun: this.selectAllFun
        }
      ],
      topSelects: [
        '门禁设备',
        '访客设备',
        '支付设备',
        '节点设备',
        '屏显设备',
        '手持设备',
        '门牌设备'
      ],
      columns: [
        {
          title: '版本号',
          dataIndex: 'version',
          sorter: true,
          width: 110
        },
        {
          title: '上传时间',
          dataIndex: 'createTime',
          sorter: true,
          width: 227,
          type: 'YY-MM-DD hh:mm:ss'
        },
        {
          title: '适用设备',
          dataIndex: 'type',
          sorter: true,
          width: 140
        },
        {
          title: '设备型号',
          dataIndex: 'equType',
          sorter: true,
          width: 140
        },
        {
          title: '版本包类型',
          dataIndex: 'packType',
          sorter: true,
          width: 140
        },
        {
          title: '版本大小',
          dataIndex: 'size',
          sorter: true,
          custom: true
          // width: 212
        },
        {
          title: '上传结果',
          dataIndex: 'status',
          custom: true,
          width: 180
        },
        {
          title: '更新描述',
          dataIndex: 'remark',
          type: 'tooltip',
          width: 400
        }
      ],
      operateA: [
        {
          name: '编辑',
          fun: this.addPageOrEditPage
        },
        {
          name: '删除',
          fun: this.rowDel
        }
      ],
      operateWidth: 140
    }
  },
  computed: {},
  mounted () {
    // // 获取版本列表
    // this.getTableData(VersionServices.GetVersionTable)
    // // // 获得删除接口
    // this.tableServices.delServices = VersionServices.DelSelected
  },
  // 缓存组件激活
  async activated () {
    // 获取版本列表
    await this.getTableData(VersionServices.GetVersionTable)

    // 获得删除接口
    this.tableServices.delServices = VersionServices.DelSelected
  },
  // 缓存组件停用
  deactivated () {},
  watch: {
    // 监控data中的数据变化
    tableData: {
      immediate: true,
      handler: function (val) {
        this.VERSIONMANAGE_TABLETADE()
      }
    }
  },
  methods: {
    ...mapMutations('versionmanage', ['VERSIONMANAGE_TABLETADE']),
    // 编辑?新增?
    addPageOrEditPage (item) {
      if (item && item.status === 0) {
        this.$message.warning('文件上传中无法编辑操作！')
        return
      }
      if (item && item.status === 2) {
        this.$router.push(
          `/version/modify-form?sn=${item.id}&type=retransmission`
        )
        return
      }
      if (item && item.id) {
        this.$router.push(`/version/modify-form?id=${item.id}`)
      } else {
        this.$router.push('/version/modify-form')
      }
    },

    // 日期范围设定
    setDateRange (date, dateString) {
      if (date.length === 0) {
        this.searchObj.startTime = ''
        this.searchObj.endTime = ''
      } else {
        this.searchObj.startTime = dateString[0] + ' 00:00:00'
        this.searchObj.endTime = dateString[1] + ' 23:59:59'
      }
    }
  }
}
</script>
<style lang="less" scoped>
// @import url(); 引入公共css类
.version-manage {
  .top-bar-input {
    width: 396px;
    margin-right: 24px;
  }
}
</style>
